import { EntityTypes } from "../../EntityTypes";
import { IHydraResource, ITimestampable } from "../../types";

export interface ISkillDomainResource extends IHydraResource, ITimestampable {
    "@type": EntityTypes.SKILL_DOMAIN;
    title: string;
}

export function isSkillDomainResource(resource: IHydraResource): resource is ISkillDomainResource {
    return resource["@type"] === EntityTypes.SKILL_DOMAIN;
}
